
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import { createReconContext } from "@/script/apps/recon/config/ReconConfig";
import { Recon } from "@/script/apps/recon/entity/ReconEntity";

@Options({})
export default class ReconDetail extends BaseDetail {
  public initData(): ServiceContext {
    return createReconContext();
  }

  public newEntity() {
    const entity: Recon = {
      node: { name: "" },
      camera: { name: "" },
      cruise: { name: "" },
    };
    return entity;
  }
}
